import {ELECTRO_TYPE} from "../../../constants/Constants";
import BaseLocomotive from "./BaseLocomotive";

class ElectroLocomotive extends BaseLocomotive
{
    constructor(parentStation, id, state)
    {
        super(parentStation, id, state, 0);
        this.movementType = ELECTRO_TYPE;
    }
}

export default ElectroLocomotive;